<template>
  <v-btn
    fab x-small dark
    color="primary"
    class="mt-n1 mr-n1"
    v-on="scope.on"
  >
    <v-icon small>mdi-square-edit-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ActivatorButton',

  props: ['scope'],
}
</script>